<div class="row" style="margin-top:30px;">
    <div class="col-12 text-end" style="height:50px;background-color: #002F87;border: 1px black solid;">
        <div style="margin-top:10px;">
            <span style="font-size:28px;color:white"><strong>TEST-Invoice Details</strong></span>
        </div>
    </div>
</div>


<div class="row billingLine" style="height:50px;">
    <div class="col-1 text-center" >
        <span class="billing-line-title">Qty</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Rate</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Rev Type</span>
    </div>
     <div class="col-4 text-center">
        <span class="billing-line-title">Description</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Seq Start</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Seq End</span>
    </div>
     <div class="col-1 text-end">
        <span class="billing-line-title">Amount</span>
    </div>
     <div class="col-1 text-end">
        <span class="billing-line-title">Tax</span>
    </div>
      <div class="col-1 text-end">
        <span class="billing-line-title">Totals</span>
    </div>
</div>
    


    <div class="row billingLine">
        <div class="col-1 text-center" style="height:60px;">
           1
        </div>
        <div class="col-1 text-center" >
            $100.00
        </div>
        <div class="col-1 text-center" >
            Monthly Parking
        </div>
        <div class="col-4 text-center" >
            Description
        </div>
        <div class="col-1 text-center" >
            101
        </div>
        <div class="col-1 text-center" >
            102
        </div>
        <div class="col-1 text-end" >
            $100.00
        </div>
        <div class="col-1 text-end" >
            $26.00
        </div>
        <div class="col-1 text-end">
            $126.00
        </div>
    </div>



<div style="width:100%;margin-left:10px;margin-right:10px;">
<div class="row" style="margin-top:30px;">
<table style="margin-top:20px;background-color: #002F87;border: 1px black solid;width:100%">
<tr>

    <div class="col-12 text-end" style="height:50px;">
        <div style="margin-top:10px;">
            <span style="font-size:28px;color:white"><strong>TEST-Invoice Details</strong></span>
        </div>
    </div>

</tr>
  <tr>
    <th>Col 1</th>
    <th>Col 2</th>
    <th>Col 3y</th>
  </tr>
  <tr>
    <td>1</td>
    <td>A</td>
    <td>AA</td>
  </tr>
  <tr>
    <td>2</td>
    <td>B</td>
    <td>BB</td>
  </tr>
</table>
</div>

</div>

    
    <!-- <div class="row" style="margin-top:20px;">
        <div class="col-8"></div>
        <div class="col-1 text-end" style="max-height:60px;border: 1px solid black;">
           <span class="billing-line-title">Subtotal</span>
        </div>
      
        <div class="col-1 text-end" style="border: 1px solid black;">
            <span class="billing-line-title">$1,000.00</span>
        </div>
        <div class="col-1 text-end"  style="border: 1px solid black;">
            <span class="billing-line-title">$125.00</span>
        </div>
        <div class="col-1 text-end"  style="border: 1px solid black;">
            <span class="billing-line-title">S1,125.00</span>
        </div>
    </div> -->

